import { Subsection } from '@zinnia/form-engine-sdk';

export const blockingStep: Subsection = {
  id: 'halt',
  blueprintId: 'eaeac006-0f4c-460a-a0d7-87fd919cec56',
  title: {
    en: '',
    fr: '',
  },
  index: 'blocking',
  fieldGroups: [],
};
